<template>
<div id="app" class="app">
	<Navgation></Navgation>
	<router-view class="view-content"></router-view>
    <Loading v-if="loading"></Loading>
</div>
</template>
<script>
import Navgation from '@/components/TheNavigation';
import Loading from '@/components/TheLoading.vue';
export default {
    components: {
        Navgation,
        Loading
    },
    computed: {
        loading() {
            return this.$store.state.loading;
        }
    },
};
</script>
<style lang="scss">
@import './style/common';
.app {
    box-sizing: border-box;
    min-height: 100vh;
    background-color: $bigbgColor;
    min-width: 16.18rem;
    .view-content {
        padding-bottom: 2rem;
    }
}
.el-image-viewer__canvas{
    img{
       width:fit-content !important;
    }
}
</style>



// WEBPACK FOOTER //
// src/App.vue